import { render, staticRenderFns } from "./PreRegistrationForm.vue?vue&type=template&id=b2234bd6&"
import script from "./PreRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./PreRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./PreRegistrationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports